import type { IconProps } from '@src/components/icons/IconProps';

/** Participant ID card: portrait and two text lines inside a rounded frame. */
export function IdCardIcon({ className }: IconProps) {
  return (
    <svg
      className={className}
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      <rect x="2" y="4.5" width="20" height="15" rx="2.5" />
      <circle cx="8" cy="10" r="2" />
      <path d="M5.5 15.5v-.75a2.5 2.5 0 0 1 5 0v.75zM14 9h4.5M14 13h4.5" />
    </svg>
  );
}
